
import { defineComponent, ref } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
export default defineComponent({
  name: "invoices",
  props: {
    cardClasses: String,
    invoices: Array,
  },
  components: {
    Datatable,
  },
  setup() {
    const tableHeader = ref([
      {
        name: "Order id",
        key: "rand_number",
        sortable: true,
      },
      {
        name: "Amount",
        key: "total_price",
        sortable: true,
      },
      {
        name: "Status",
        key: "status",
        sortable: true,
      },
      {
        name: "Customer",
        key: "customer",
        sortable: true,
      },
      {
        name: "Date",
        key: "release_date",
        sortable: true,
      },
      {
        name: "Invoice",
        key: "invoice",
        sortable: false,
      },
    ]);

    return { tableHeader };
  },
});
